import React from 'react';
import PropTypes from 'prop-types';

import { SuiCollapsible } from '@splashthat/sui';
import FormStyleEditorHeader from './FormStyleEditorHeader';

import { collapsibleLabels, styleEditorPanels } from '../../constants/formStylePanels';

export default class FormStyleCollapsibles extends React.Component {
    static propTypes = {
        panels: PropTypes.array,
        collapsibleContentComponents: PropTypes.object,
        openCollapsible: PropTypes.oneOf(styleEditorPanels),
        setOpenStyleEditorSection: PropTypes.func.isRequired,
    };

    static defaultProps = {
        panels: [],
        collapsibleContentComponents: {},
        openCollapsible: null,
    };

    renderPanel(identifier) {
        return (
            <SuiCollapsible
                key={identifier}
                fullWidth
                header={<FormStyleEditorHeader label={collapsibleLabels[identifier]} qaId={identifier} />}
                content={this.props.collapsibleContentComponents[identifier] || '-'}
                icon={undefined}
                isOpen={this.props.openCollapsible === identifier}
                onToggleHeader={() => this.handleOnToggleCollapsible(identifier)}
            />
        );
    }

    handleOnToggleCollapsible = (collapsibleId) => {
        const newOpenCollapsible = this.props.openCollapsible === collapsibleId ? null : collapsibleId;
        this.props.setOpenStyleEditorSection(newOpenCollapsible);
    };

    render() {
        return this.props.panels.map((identifier) => this.renderPanel(identifier));
    }
}
